export const paths = {
  home: '/',
  results: '/results',
  about: '/about',
  faq: '/faq'
};
